import { AccessibleProduct } from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { societiesQueryKeys } from "../query-keys/societies.query-keys";

export const useGetBrokerProducts = (brokerId: number) => {
	const isValidId = brokerId > 0;

	return useQuery({
		queryKey: societiesQueryKeys.brokerProducts(brokerId),
		queryFn: async () => {
			const { data } = await privateAxios.get<AccessibleProduct[]>(
				`/societies/${brokerId}/products`,
			);
			return data;
		},
		enabled: isValidId,
	});
};
